<template>
  <div class="PresentPersonelListWeb">
    <v-data-table
      dense
      :disable-sort="false"
      :headers="headers"
      :items="list"
      :hide-default-footer="!pagination"
      :disable-pagination="!pagination"
      :footer-props="{
        'items-per-page-options': [5, 10, 15, 50, 100, -1],
        'items-per-page-text': $t('rowsPerPage'),
        'show-first-last-page': true,
      }"
      @click:row="handleClick"
    >
      
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    pagination: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    list() {
      this.selectedList = [];
    },
  },
  data() {
    return {
      selectedList: [],
      headers: [
        {
          text: this.$t("card-no"),
          value: "PERNO",
        },
        {
          text: this.$t("person-name"),
          value: "PersonName",
        },
        {
          text: this.$t("SectionName"),
          value: "Section",
        },
        {
          text: this.$t("WorkGroup"),
          value: "WorkGroupName",
        },
        
      ],
    };
  },
  methods: {
    handleClick(value) {
      this.$emit("onClick", value);
    },
  },
};
</script>

<style>
tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.329);
}
</style>